import React, { createContext } from 'react';

import useUsers from "../useUsers";

export const UsersContext = createContext([]);

const UsersWrapper = ({ children }) => {
  const usersState = useUsers()
  return (
    <UsersContext.Provider value={usersState}>
      {children}
    </UsersContext.Provider>
  )
}
export default UsersWrapper;
